import { all_routes } from '../router/all_routes';
import { PermissionType } from '../types/user.types';
import { UserNotificationPayload } from '../types/userNotification.types';

/**
 * Push bildirim payload'ındaki mobil ekran adını (data.screen) web'deki karşılık gelen
 * sayfaya çevirir. Kullanıcının o sayfaya yetkisi yoksa veya eşleşme yoksa null döner
 * (çağıran taraf bu durumda bildirim kutusu sayfasına yönlendirir).
 */
export const getNotificationTargetRoute = (
  data: UserNotificationPayload | null | undefined,
  permissions?: (PermissionType | string)[] | null
): string | null => {
  const screen = data?.screen;
  if (!screen) return null;

  const has = (permission: PermissionType) => !!permissions?.some((p) => p === permission);

  switch (screen) {
    case 'FieldModeApproval':
    case 'FieldModeRequests':
      return has(PermissionType.FIELD_MODE_REQUESTS) ? all_routes.fieldModeRequests : null;
    case 'FieldActivityApproval':
      return has(PermissionType.VIEW_FIELD_ACTIVITIES) ? all_routes.activityRequests : null;
    case 'EmployeeWantRequest':
      if (has(PermissionType.VIEW_LEAVE)) return all_routes.leaveadmin;
      if (has(PermissionType.LEAVE_REQUEST)) return all_routes.leaveemployee;
      return null;
    case 'OvertimeApproval':
      return has(PermissionType.OVERTIME) ? all_routes.overtimePending : null;
    case 'AllTicketsAdmin':
      return has(PermissionType.VIEW_TICKETS_ADMIN) ? all_routes.ticketAdmin : null;
    case 'Subscription':
      // Web'de abonelik/plan yönetimi Şirket Ayarları sayfasında yapılıyor
      return has(PermissionType.COMPANY) ? all_routes.companySettings : null;
    default:
      return null;
  }
};
